<template>
  <div v-if="visible" class="confirm-overlay" @click="handleOverlayClick">
    <div class="confirm-container" @click.stop>
      <div class="confirm-header">
        <div class="confirm-title">{{ title }}</div>
      </div>
      <div class="confirm-content">
        <p>{{ content }}</p>
      </div>
      <div class="confirm-footer">
        <button class="confirm-btn cancel-btn" @click="handleCancel">
          {{ cancelText }}
        </button>
        <button class="confirm-btn ok-btn" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    // 是否显示对话框
    visible: {
      type: Boolean,
      default: false
    },
    // 对话框标题
    title: {
      type: String,
      default: '提示'
    },
    // 对话框内容
    content: {
      type: String,
      default: '确定执行此操作吗？'
    },
    // 取消按钮文本
    cancelText: {
      type: String,
      default: '取消'
    },
    // 确认按钮文本
    confirmText: {
      type: String,
      default: '确认'
    },
    // 点击遮罩是否关闭
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 处理遮罩点击
    handleOverlayClick() {
      if (this.closeOnClickModal) {
        this.handleCancel();
      }
    },
    
    // 处理取消
    handleCancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
    },
    
    // 处理确认
    handleConfirm() {
      this.$emit('confirm');
      this.$emit('update:visible', false);
    }
  }
}
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.confirm-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: slideUp 0.3s ease;
  width: 400px;
  max-width: 90%;
}

.confirm-header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
}

.confirm-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.confirm-content {
  padding: 20px;
  font-size: 14px;
  color: #606266;
  text-align: center;
}

.confirm-footer {
  display: flex;
  justify-content: center;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  gap: 15px;
}

.confirm-btn {
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  min-width: 80px;
}

.cancel-btn {
  background-color: white;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.cancel-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.ok-btn {
  background-color: #409eff;
  color: white;
}

.ok-btn:hover {
  background-color: #66b1ff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>